export default __webpack_public_path__ + "static/media/foto_03.171db182.jpg";